import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import DSC_4747r from "../downloads/Selects for Website/DSC_4747r.jpg";
import DSC_9945r from "../downloads/Selects for Website/DSC_9945r.JPG";
import DSC_DRMr from "../downloads/Selects for Website/DSC_DRMr.JPG";
import DSC_4078r from "../downloads/Selects for Website/DSC_4078r.JPG";
import DSC_9767r from "../downloads/Selects for Website/DSC_9767r.JPG";

import "./About.css";

const Home = () => {
  return (
    <header className="App-header">
      <div className="aboutContainer">
        <div className="aboutBackgroundImage">
          <div
            id="carouselExample"
            className="about__carousel carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner wh-100p">
              <div className="carousel-item active">
                <img src={DSC_DRMr} className="about__image" alt="portrait1" />
              </div>
              <div className="carousel-item">
                <img src={DSC_9945r} className="about__image" alt="portrait2" />
              </div>
              <div className="carousel-item">
                <img src={DSC_4747r} className="about__image" alt="portrait3" />
              </div>
              <div className="carousel-item">
                <img src={DSC_4078r} className="about__image" alt="portrait4" />
              </div>
              <div className="carousel-item">
                <img src={DSC_9767r} className="about__image" alt="portrait5" />
              </div>
            </div>

            <button
              className="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExample"
              data-bs-slide="prev"
            >
              <span className="carousel-control-prev-icon" aria-hidden="true" />
              <span className="visually-hidden">Previous</span>
            </button>

            <button
              className="carousel-control-next"
              type="button"
              data-bs-target="#carouselExample"
              data-bs-slide="next"
            >
              <span className="carousel-control-next-icon" aria-hidden="true" />
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div className="aboutText">
          <h1>About Us</h1>
          <p className="bodyFont">
            Image Group Photography has been doing corporate, retail, and
            commercial photography for over 40 years. We have the latest
            equipment, technology and software for photographing on location or
            in our spacious 3,000 square foot studio space. Our fully-equipped
            studio includes a spacious waiting area, two changing rooms, and two
            post-production rooms. We can provide the highest quality images of
            your employees, office space, buildings, equipment, products and
            special events so you can market your business with professional
            imagery. Please contact us at{" "}
            <a
              href="tel:+18159321242"
              style={{
                textDecoration: "none",
                userSelect: "text",
              }}
            >
              1-815-932-1242
            </a>{" "}
            to discuss your photography needs.
          </p>
        </div>
      </div>
    </header>
  );
};

/* Potential Text for About Page

///////////////////////////////////////////////////////////////

Image Group Photography has been doing corporate, retail, and commercial photography for over 30 years. 
We have the latest equipment, technology and software for photographing on location or in our spacious 3,000 square foot studio space. 
Our fully-equipped studio includes a spacious waiting area, two changing rooms, two post-production rooms, and a comfortable “projection room” for private and personalized photo planning, viewing, and selection. 
Our staff includes multiple professionally trained photographers, photographer assistants, and an in-house designer. 
We can provide the highest quality images of your employees, office space, buildings, equipment, products and special events so you can market your business with professional imagery. 
Please contact us at 815-932-1230 to discuss your photography needs.

///////////////////////////////////////////////////////////////


In the language of distinctive photography, luck has no meaning.  Our uncompromising approach to quality places the needs of our clients first and foremost, combining the diverse talents of five photographers as well as in-studio graphic designers.  The ability to produce a flawless image requires a relentless pursuit for perfection.  We achieve this standard on a daily basis by incorporating our production lab within our studio for absolute control.  Digital technology has revolutionized photography.  Our studio has specialized in digital for the past decade and we pride ourselves on our state-of-the art equipment and digital expertise which allow us to meet the needs of the most discriminating client.

 We offer a wide variety of photographic services ranging from weddings and seniors to commercial and corporate medical photography.  In addition, digital services such as graphic design and DVD authoring are also available.


 
*/

export default Home;
